import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAdminHubUi } from "../../../hooks/useAdminAppMode";
import { DOCTORS_BASE } from "../AdminDoctors/doctorConstants";
import { TEAM_BASE } from "./teamConstants";
import TeamInviteForm from "./TeamInviteForm";
import s from "../clinic.module.css";
import { Card } from "../../ui";

export default function AdminTeamInvite() {
  const navigate = useNavigate();
  const isApp = useAdminHubUi();

  if (isApp) {
    return <Navigate to={`${TEAM_BASE}?invite=1`} replace />;
  }

  const handleSuccess = (res) => {
    const tid = res?.member?.trainer_id;
    if (tid) {
      navigate(`${DOCTORS_BASE}/${tid}`);
    } else {
      navigate(TEAM_BASE);
    }
  };

  return (
    <div className={s.patientPage}>
      <nav className={`${s.patientBreadcrumbs} ${s.patientPageBlock}`}>
        <Link to={TEAM_BASE}>Команда</Link>
        <span aria-hidden>/</span>
        <span>Приглашение</span>
      </nav>

      <Card
        title="Пригласить в команду"
        subtitle="Назначьте роль, направления, группы и залы"
      >
        <TeamInviteForm
          onSuccess={handleSuccess}
          onCancel={() => navigate(TEAM_BASE)}
        />
      </Card>
    </div>
  );
}
